/* ============================================================
   Villand • Cart upsell + recomendações (Shopify Search & Discovery)
   - Busca /recommendations/products (intent related|complementary) por um
     produto-semente do carrinho e injeta cards num carrossel scroll-snap.
   - "Adicionar" adiciona a variante e re-renderiza a gaveta via o evento
     canônico do tema (cart:refresh) → o item aparece na hora.
   - "Continuar comprando" fecha a gaveta.
   ============================================================ */
(function () {
  if (window.__vlUpsellBound) return;
  window.__vlUpsellBound = true;

  var lastSeed = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function unlock(button) {
    if (!button) return;
    button.removeAttribute('disabled');
    button.classList.remove('m-spinner-loading');
  }

  function addVariant(variantId, button) {
    if (!variantId) return;
    button.setAttribute('disabled', 'disabled');
    button.classList.add('m-spinner-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status !== 200) {
          console.warn('[vl-upsell] add error:', res.description || res.message);
          unlock(button);
          return;
        }
        // Re-render canônico da gaveta (rebusca a seção do servidor) + abre.
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        // Recarrega as recomendações para o novo conteúdo do carrinho.
        lastSeed = null;
        setTimeout(loadRecommendations, 700);
      })
      .catch(function (e) {
        console.error('[vl-upsell]', e);
        unlock(button);
      });
  }

  // Busca recomendações do Search & Discovery por um produto-semente do carrinho.
  function loadRecommendations() {
    var box = document.querySelector('[data-vl-rec]');
    if (!box) return;
    var track = box.querySelector('[data-vl-rec-track]');
    if (!track) return;

    if (track.children.length) box.removeAttribute('hidden'); // mostra fallback de imediato

    var intent = box.getAttribute('data-intent') || 'related';
    var limit = box.getAttribute('data-limit') || 6;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { box.setAttribute('hidden', ''); return; }
        var seed = cart.items[cart.items.length - 1].product_id;
        if (seed === lastSeed && track.children.length) return;
        lastSeed = seed;

        var url = root() + 'recommendations/products?section_id=cart-recommendations'
          + '&product_id=' + seed + '&intent=' + intent + '&limit=' + limit;

        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = Array.prototype.slice.call(doc.querySelectorAll('.vl-rec__card'));
            if (cards.length) {
              track.replaceChildren.apply(track, cards.map(function (c) { c.setAttribute('role', 'listitem'); return c; }));
              box.removeAttribute('hidden');
            } else if (!track.children.length) {
              box.setAttribute('hidden', '');
            }
          });
      })
      .catch(function () { /* mantém fallback */ });
  }

  function closeDrawer() {
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.close === 'function') { drawer.close(); return; }
    var btn = document.querySelector('.m-cart-drawer__close');
    if (btn) btn.click();
  }

  // Delegação de cliques (sobrevive ao re-render)
  document.addEventListener('click', function (event) {
    var add = event.target.closest('[data-vl-upsell-add]');
    if (add) { event.preventDefault(); addVariant(add.getAttribute('data-variant-id'), add); return; }
    var cont = event.target.closest('[data-vl-continue-shopping]');
    if (cont) { event.preventDefault(); closeDrawer(); return; }
  });

  // Recarrega recomendações quando o carrinho muda (add nativo) e no load
  document.addEventListener('cart:updated', function () { lastSeed = null; loadRecommendations(); });
  document.addEventListener('DOMContentLoaded', loadRecommendations);
  loadRecommendations();
})();
